import { DownloadHistory, FolderHistory } from "../../../domain/history";
import { DateTimeConverter } from "../../utilities";
import { IDownloadHistoryBean, IFolderHistoryBean } from "../beans";

export class HistoryTranslator {
  static toFolderHistory(bean: IFolderHistoryBean): FolderHistory {
    if (!bean) { throw new Error("bean is empty!!!"); }

    const result = new FolderHistory();
    result.folderId = bean.folderId;
    result.createDateTime = DateTimeConverter.toDate(bean.createDateTime);
    result.updateDateTime = DateTimeConverter.toDate(bean.updateDateTime);
    result.comment = bean.comment;
    result.password = bean.password;
    result.published = bean.published;
    result.isDeleted = bean.isDeleted;
    return result;
  }

  static toDownloadHistory(bean: IDownloadHistoryBean): DownloadHistory {
    if (!bean) { throw new Error("bean is empty!!!"); }
    
    const result = new DownloadHistory();
    result.dateTime = DateTimeConverter.toDate(bean.dateTime);
    result.userName = bean.userName;
    result.fileName = bean.fileName;
    result.ipAddress = bean.ipAddress;
    return result;
  }
}
